import styled, { keyframes } from "styled-components";

import yelloMark from "../../../../image/assets/yellow-mark.png";

import VideoPlayerComponent from "../../videoPlayer";

export const StyledSection = styled.section`
  background: var(--blue-color-light);
  margin-top: -90px;
  p {
    color: var(--dark-color);
    font-size: var(--font-size-xl);
    font-weight: 500;
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-sm);
    }
    mark {
      color: inherit;
      background: url(${yelloMark}) no-repeat center;
      background-size: contain;
      @media screen and (max-width: 576px) {
        background-position: 0 80%;
      }
    }
  }
`;

const shapesAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-2px);
  }
  50% {
    transform: translateY(-3px);
  }
  100% {
    transform: translateY(0);
  }
`;
export const StyledShapes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  height: 100%;
  width: 30%;
  margin: 0 auto;
  animation: ${shapesAnimation} 1s linear infinite;
  svg:nth-child(1) {
    transform: rotate(50deg);
  }
  svg:nth-child(2) {
    transform: rotate(90deg);
    align-self: ${({ right }) => right && "end"};
  }
  svg:nth-child(3) {
    align-self: ${({ left }) => left && "start"};
  }

  @media screen and (max-width: 992px) {
    height: 75%;
    background-position: 0 80%;
    svg {
      width: 35px;
    }
  }
  @media screen and (max-width: 576px) {
    height: 80%;
    svg {
      width: 18px;
    }
  }
`;

// Width and height for video and iframe, Aspect ratio is 16/9
export const frameWidth = "650";
export const frameHeight = "365";

export const TabletWrapper = styled.div`
  position: relative;
  border: 16.5px solid #121212;
  border-radius: 12px;
  outline: 2px solid #6c6d72;
  width: fit-content;
  margin: 0 auto;
  &:after {
    content: "";
    position: ${({ isShowSim }) => !isShowSim && "absolute"};
    top: -1px;
    left: -2px;
    width: calc(100% + 4px);
    height: calc(100% + 1px);
    background-color: #4ec09e;
    text-align: center;
    opacity: 0.75;
    cursor: pointer;
  }
  iframe {
    margin: -1px -2px -10px -2px;
    border: none;
    @media screen and (max-width: 992px) {
      width: ${frameWidth / 1.6}px;
      height: ${frameHeight / 1.6}px;
    }
    @media screen and (max-width: 768px) {
      width: ${frameWidth / 1.5}px;
      height: ${frameHeight / 1.5}px;
    }
    @media screen and (max-width: 576px) {
      width: ${frameWidth / 2.4}px;
      height: ${frameHeight / 2.4}px;
    }
    @media screen and (max-width: 345px) {
      width: ${frameWidth / 3}px;
      height: ${frameHeight / 3}px;
    }
  }
  @media screen and (max-width: 576px) {
    border: 9px solid #121212;
  }
`;

export const StyledVideoPlayer = styled(VideoPlayerComponent)`
  aspect-ratio: 16/9;
  margin: -1px -2px -10px -2px;
  border: none;
  width: ${frameWidth}px;
  height: ${frameHeight}px;
  @media screen and (max-width: 992px) {
    width: ${frameWidth / 1.6}px;
    height: ${frameHeight / 1.6}px;
  }
  @media screen and (max-width: 768px) {
    width: ${frameWidth / 1.6}px;
    height: ${frameHeight / 1.6}px;
  }
  @media screen and (max-width: 576px) {
    width: ${frameWidth / 2.4}px;
    height: ${frameHeight / 2.4}px;
  }
  @media screen and (max-width: 345px) {
    width: ${frameWidth / 3}px;
    height: ${frameHeight / 3}px;
  }
`;

export const SimCoverContent = styled.div`
  color: var(--white-color);
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media screen and (max-width: 576px) {
    font-size: var(--font-size-sm);
  }
`;

export const SimCursorContainer = styled.div`
  width: 100px;
  height: 100px;
  border: 1.5px dashed var(--white-color);
  border-radius: 7px;
  cursor: pointer;
  display: flex;
  flex-wrap: column;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 576px) {
    width: 50px;
    height: 50px;
    img {
      height: 20px;
      width: 16px;
    }
  }
`;
